import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Video } from 'expo-av';
import { formatDuration } from '../../utils/video';

interface VideoDurationBadgeProps {
  initialDuration: string;
  videoUrl?: string;
  videoType?: 'native' | 'youtube';
  style?: any;
}

export const VideoDurationBadge: React.FC<VideoDurationBadgeProps> = ({
  initialDuration,
  videoUrl,
  videoType,
  style,
}) => {
  const [duration, setDuration] = useState<string>(initialDuration);

  useEffect(() => {
    setDuration(initialDuration);
  }, [initialDuration]);

  const handleVideoLoad = (status: any) => {
    if (status.isLoaded && status.durationMillis) {
      const seconds = Math.floor(status.durationMillis / 1000);
      const formatted = formatDuration(seconds);
      if (formatted) {
        setDuration(formatted);
      }
    }
  };

  if (!duration || duration === '' || duration === '0:00') {
    if (videoType === 'native' && videoUrl) {
      return (
        <Video
          source={{ uri: videoUrl }}
          onLoad={handleVideoLoad}
          shouldPlay={false}
          style={{ width: 0, height: 0, position: 'absolute' }}
        />
      );
    }
    return null;
  }

  return (
    <View style={[styles.durationContainer, style]}>
      <Text style={styles.durationText}>{duration}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  durationContainer: {
    position: 'absolute',
    bottom: 8,
    right: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    zIndex: 10,
  },
  durationText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
  },
});
